export default __webpack_public_path__ + "static/media/haj5.6b6cfd06.jpg";